export default __webpack_public_path__ + "static/media/Group7555.e6308927.png";